import React from 'react';
import { Alert } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Centered = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 80vh;
`;

const Version = styled.div`
    position: absolute;
    bottom: 0;
    right: 0;
`;

const ErrorPage = () => {
    return (
        <Centered>
            <Alert type='error' message='404' description='nothing found' />
            <Link to='/'>Go to home page</Link>
            <Version>{process.env.REACT_APP_GIT_TAG}</Version>
        </Centered>
    );
};

export default ErrorPage;
